import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  reportTotal: [],
  entities: [],
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const slice = createSlice({
  name: "salesReports",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getLocationById
    fetchById: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // get list data
    fetchedAll: (state, action) => {
      const { totalCount, entities, reportTotal } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities.map((e, i) => ({ ...e, id: i }));
      state.totalCount = totalCount;
      state.reportTotal = reportTotal;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
  },
});
